<template>
  <div class="vip-products-container">
    <el-card class="full-height-card">
      <div slot="header" class="header-container">
        <span>VIP卡片管理</span>
        <el-button type="primary" size="small" @click="handleAdd">新增VIP卡片</el-button>
      </div>
      
      <!-- 搜索表单 -->
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item>
          <el-input v-model="searchForm.level" placeholder="会员等级" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
      
      <!-- 移动端卡片列表 -->
      <div class="mobile-cards" v-if="isMobile">
        <el-card v-for="vip in vipProductList" :key="vip.id" class="mobile-card">
          <div class="card-header">
            <span class="vip-level">{{ vip.level }}</span>
            <el-tag :type="vip.deleted === 0 ? 'success' : 'danger'" size="small">
              {{ vip.deleted === 0 ? '正常' : '已删除' }}
            </el-tag>
          </div>
          <div class="card-content">
            <div class="info-item">
              <span class="label">价格：</span>
              <span>{{ vip.price }} USDT</span>
            </div>
            <div class="info-item">
              <span class="label">日额度：</span>
              <span>{{ vip.dayQuote }} USDT</span>
            </div>
            <div class="info-item">
              <span class="label">月额度：</span>
              <span>{{ vip.monthQuote }} USDT</span>
            </div>
            <div class="info-item">
              <span class="label">创建时间：</span>
              <span>{{ formatDate(vip.createTime) }}</span>
            </div>
            <div class="info-item">
              <span class="label">更新时间：</span>
              <span>{{ formatDate(vip.updateTime) }}</span>
            </div>
          </div>
          <div class="card-footer">
            <el-button-group>
              <el-button size="mini" @click="handleEdit(vip)">编辑</el-button>
              <el-button size="mini" type="danger" @click="handleDelete(vip)">删除</el-button>
            </el-button-group>
          </div>
        </el-card>
      </div>
      
      <!-- PC端表格 -->
      <el-table
        v-else
        v-loading="loading"
        :data="vipProductList"
        border
        style="width: 100%">
        <el-table-column
          prop="id"
          label="ID"
          width="80">
        </el-table-column>
        <el-table-column
          prop="level"
          label="会员等级"
          width="120">
          <template slot-scope="scope">
            <el-input 
              v-if="scope.row.isEdit" 
              v-model="scope.row.level" 
              size="small">
            </el-input>
            <span v-else>{{ scope.row.level }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="price"
          label="价格(USDT)"
          width="120">
          <template slot-scope="scope">
            <el-input 
              v-if="scope.row.isEdit" 
              v-model.number="scope.row.price" 
              type="number"
              size="small">
            </el-input>
            <span v-else>{{ scope.row.price }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="dayQuote"
          label="日额度(USDT)"
          width="120">
          <template slot-scope="scope">
            <el-input 
              v-if="scope.row.isEdit" 
              v-model.number="scope.row.dayQuote" 
              type="number"
              size="small">
            </el-input>
            <span v-else>{{ scope.row.dayQuote }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="monthQuote"
          label="月额度(USDT)"
          width="120">
          <template slot-scope="scope">
            <el-input 
              v-if="scope.row.isEdit" 
              v-model.number="scope.row.monthQuote" 
              type="number"
              size="small">
            </el-input>
            <span v-else>{{ scope.row.monthQuote }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="deleted"
          label="状态"
          width="100">
          <template slot-scope="scope">
            <el-select 
              v-if="scope.row.isEdit" 
              v-model="scope.row.deleted" 
              size="small" 
              style="width: 100%">
              <el-option label="正常" :value="0"></el-option>
              <el-option label="已删除" :value="1"></el-option>
            </el-select>
            <el-tag v-else :type="scope.row.deleted === 0 ? 'success' : 'danger'">
              {{ scope.row.deleted === 0 ? '正常' : '已删除' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="更新时间"
          width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.updateTime) }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="180">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.isEdit"
              size="mini"
              type="success"
              @click="saveEdit(scope.row)"
              :loading="scope.row.saveLoading">保存</el-button>
            <el-button
              v-if="scope.row.isEdit"
              size="mini"
              @click="cancelEdit(scope.row)">取消</el-button>
            <el-button
              v-if="!scope.row.isEdit"
              size="mini"
              @click="handleEdit(scope.row)">编辑</el-button>
            <el-button
              v-if="!scope.row.isEdit"
              size="mini"
              type="danger"
              @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
        </el-pagination>
      </div>
    </el-card>
    
    <!-- 新增会员产品对话框 -->
    <el-dialog title="新增VIP卡片" :visible.sync="addDialogVisible" width="500px">
      <el-form :model="addForm" :rules="rules" ref="addForm" label-width="120px">
        <el-form-item label="会员等级" prop="level">
          <el-input v-model="addForm.level"></el-input>
        </el-form-item>
        <el-form-item label="价格(USDT)" prop="price">
          <el-input-number v-model="addForm.price" :min="0" :precision="2" :step="100"></el-input-number>
        </el-form-item>
        <el-form-item label="日额度(USDT)" prop="dayQuote">
          <el-input-number v-model="addForm.dayQuote" :min="0" :precision="2" :step="5"></el-input-number>
        </el-form-item>
        <el-form-item label="月额度(USDT)" prop="monthQuote">
          <el-input-number v-model="addForm.monthQuote" :min="0" :precision="2" :step="10"></el-input-number>
        </el-form-item>
        <el-form-item label="状态" prop="deleted">
          <el-select v-model="addForm.deleted" placeholder="请选择状态">
            <el-option label="正常" :value="0"></el-option>
            <el-option label="已删除" :value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAdd" :loading="submitLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'VipProducts',
  data() {
    return {
      loading: false,
      vipProductList: [],
      searchForm: {
        level: ''
      },
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      // 新增会员产品相关数据
      addDialogVisible: false,
      submitLoading: false,
      addForm: {
        level: '',
        price: 1000.00,
        dayQuote: 20.00,
        monthQuote: 60.00,
        deleted: 0
      },
      rules: {
        level: [
          { required: true, message: '请输入会员等级', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入价格', trigger: 'blur' },
          { type: 'number', message: '价格必须为数字', trigger: 'blur' }
        ],
        dayQuote: [
          { required: true, message: '请输入日额度', trigger: 'blur' },
          { type: 'number', message: '日额度必须为数字', trigger: 'blur' }
        ],
        monthQuote: [
          { required: true, message: '请输入月额度', trigger: 'blur' },
          { type: 'number', message: '月额度必须为数字', trigger: 'blur' }
        ],
        deleted: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      },
      isMobile: false
    }
  },
  methods: {
    // 获取会员产品列表
    fetchVipProductList() {
      this.loading = true
      
      const params = {
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
        level: this.searchForm.level || undefined
      }
      
      axios.get('/vip/page', { params })
        .then(response => {
          this.loading = false
          const { data } = response.data
          
          // 为每一行添加编辑状态和原始数据备份
          this.vipProductList = data.data.map(item => ({
            ...item,
            isEdit: false,
            saveLoading: false,
            originalData: { ...item } // 保存原始数据，用于取消编辑
          }))
          this.pagination.total = data.total
          this.pagination.pageNum = data.pageNum
          this.pagination.pageSize = data.pageSize
        })
        .catch(error => {
          this.loading = false
          console.error('获取会员产品列表失败:', error)
          this.$message.error('获取会员产品列表失败')
        })
    },
    
    // 搜索
    handleSearch() {
      this.pagination.pageNum = 1
      this.fetchVipProductList()
    },
    
    // 重置搜索
    resetSearch() {
      this.searchForm = {
        level: ''
      }
      this.pagination.pageNum = 1
      this.fetchVipProductList()
    },
    
    // 改变每页显示数量
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.fetchVipProductList()
    },
    
    // 改变页码
    handleCurrentChange(val) {
      this.pagination.pageNum = val
      this.fetchVipProductList()
    },
    
    // 新增会员产品
    handleAdd() {
      this.addForm = {
        level: '',
        price: 1000.00,
        dayQuote: 20.00,
        monthQuote: 60.00,
        deleted: 0
      }
      this.addDialogVisible = true
      // 在下一个事件循环中重置表单验证
      this.$nextTick(() => {
        if (this.$refs.addForm) {
          this.$refs.addForm.clearValidate()
        }
      })
    },
    
    // 提交新增
    submitAdd() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.submitLoading = true
          
          axios.post('/vip/add', this.addForm)
            .then(response => {
              this.submitLoading = false
              
              if (response.data.status === 200) {
                this.$message.success('添加成功')
                this.addDialogVisible = false
                this.fetchVipProductList() // 刷新列表
              } else {
                this.$message.error(response.data.message || '添加失败')
              }
            })
            .catch(error => {
              this.submitLoading = false
              const errorMsg = error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : '网络错误，请稍后重试'
              this.$message.error(errorMsg)
              console.error('添加会员产品失败:', error)
            })
        }
      })
    },
    
    // 编辑会员产品
    handleEdit(row) {
      // 先取消其他行的编辑状态
      this.vipProductList.forEach(item => {
        if (item.id !== row.id && item.isEdit) {
          this.cancelEdit(item)
        }
      })
      
      // 设置当前行为编辑状态
      row.isEdit = true
      // 保存原始数据，用于取消编辑
      row.originalData = { ...row }
    },
    
    // 取消编辑
    cancelEdit(row) {
      // 恢复原始数据
      Object.assign(row, row.originalData)
      row.isEdit = false
    },
    
    // 保存编辑
    saveEdit(row) {
      // 验证
      if (!row.level || (typeof row.level === 'string' && row.level.trim() === '') || row.level === '') {
        this.$message.error('会员等级不能为空')
        return
      }
      
      if (row.price === undefined || row.price === null) {
        this.$message.error('价格不能为空')
        return
      }
      
      if (row.dayQuote === undefined || row.dayQuote === null) {
        this.$message.error('日额度不能为空')
        return
      }
      
      if (row.monthQuote === undefined || row.monthQuote === null) {
        this.$message.error('月额度不能为空')
        return
      }
      
      row.saveLoading = true
      
      // 构建请求数据
      const data = {
        id: row.id,
        level: row.level,
        price: row.price,
        dayQuote: row.dayQuote,
        monthQuote: row.monthQuote,
        deleted: row.deleted
      }
      
      // 发送更新请求
      axios.post('/vip/update', data)
        .then(response => {
          row.saveLoading = false
          
          if (response.data.status === 200) {
            this.$message.success('更新成功')
            row.isEdit = false
            // 更新原始数据
            row.originalData = { ...row }
          } else {
            this.$message.error(response.data.message || '更新失败')
          }
        })
        .catch(error => {
          row.saveLoading = false
          const errorMsg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : '网络错误，请稍后重试'
          this.$message.error(errorMsg)
          console.error('更新会员产品失败:', error)
        })
    },
    
    // 删除会员产品
    handleDelete(row) {
      this.$confirm(`确认删除VIP卡片 ${row.level}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 发送删除请求
        axios.delete(`/vip/delete/${row.id}`)
          .then(response => {
            if (response.data.status === 200) {
              this.$message.success('删除成功')
              this.fetchVipProductList() // 刷新列表
            } else {
              this.$message.error(response.data.message || '删除失败')
            }
          })
          .catch(error => {
            const errorMsg = error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : '网络错误，请稍后重试'
            this.$message.error(errorMsg)
            console.error('删除会员产品失败:', error)
          })
      }).catch(() => {
        // 取消删除
      })
    },
    
    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return '未知'
      
      const date = new Date(dateStr)
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
    },
    
    // 检查是否为移动端
    checkMobile() {
      this.isMobile = window.innerWidth <= 768
    }
  },
  created() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
    this.fetchVipProductList()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
  }
}
</script>

<style scoped>
.vip-products-container {
  padding: 20px;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search-form {
  margin-bottom: 20px;
}

/* 移动端卡片样式 */
.mobile-cards {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.mobile-card {
  margin-bottom: 10px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.vip-level {
  font-size: 16px;
  font-weight: bold;
}

.card-content {
  margin: 15px 0;
}

.info-item {
  margin-bottom: 8px;
  font-size: 14px;
}

.label {
  color: #909399;
  margin-right: 5px;
}

.card-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
}

/* 响应式布局 */
@media screen and (max-width: 768px) {
  .vip-products-container {
    padding: 10px;
  }
  
  .search-form {
    display: flex;
    flex-direction: column;
  }
  
  .search-form .el-form-item {
    margin-right: 0;
    margin-bottom: 10px;
  }
  
  .pagination-container {
    margin-top: 15px;
  }
  
  .el-pagination {
    text-align: center;
  }
  
  .card-footer {
    flex-direction: column;
    gap: 10px;
  }
  
  .card-footer .el-button-group {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
  }
  
  .card-footer .el-button-group .el-button {
    margin-right: 0;
  }
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.dialog-footer {
  text-align: right;
}
</style> 